import React, { useEffect, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import MaterialTable from "material-table";
import { Link, useHistory } from "react-router-dom";
import HoursDetailsPopUP from "./HoursDetailsPopUP";
import "./hours.css";

import userService from "../../../services/user.service";
import { CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  userRoleKeyMap,
  userRoles,
  userSchoolName,
} from "../../../utils/constant";
import PageNotFound from "../../../routes/PageNotFound";
import { Paper } from "@mui/material";
import { HoursTableColumns } from "../../tableColumns/HoursTableColumn";
import { DataGrid } from "@mui/x-data-grid";
import ErrorMessage from "../../../Common/ErrorMessage";
import CustomSearch from "../../../Common/CustomSearch";
import PageNotFoundPage from "../../../Common/PageNotFoundPage";

const Hours = () => {
  const [hoursDetails, setHoursDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 10,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const history = useHistory();
  const permissionRights = useSelector(({ loggedInUser }) =>
    loggedInUser.userProfile.permissionRights.map((item) => item.displayName)
  );
  const userRole = useSelector((state) => state.loggedInUser.roles[0].role);
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      role: role,
      schoolDetails:
        role == userRoles.ROLE_SCHOOL_ADMIN
          ? user
          : user[userSchoolName[role]][0].school,
      permissionRights: loggedInUser.userProfile.permissionRights.map(
        (item) => item.displayName
      ),
    };
  });
  useEffect(() => {
    setLoading(true);
    getSportHoursData(pageState.page, pageState.size);
  }, []);

  const getSportHoursData = (page, size) => {
    setPageState((old) => ({ ...old, isLoading: true }));
    userService
      .getAllSportsHoursDetails(userInfo.schoolDetails.id)
      .then((res) => {
        const data = res.data.data;
        setHoursDetails([data]);

        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: [data],
          total: 1,
        }));

        setLoading(false);
      })
      .catch((err) => {
        console.error(setLoading(false));
      });
  };

  return (
    <div>
      {userInfo.role == userRoles.ROLE_SCHOOL_ADMIN ||
      permissionRights.includes("View Data Usage") ? (
        <div>
          <div>
            <SchoolAdminDashboard />
            <div
              className={
                isDrawerOpen
                  ? "content-layout p-0"
                  : "toggle-content-layout p-0"
              }
            >
              {loading ? (
                <div className="content-layout-loading-animation">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="mng-header stickyy">
                    <h4 className="fs-24 bold mob-hd">Hours</h4>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
                    {!loading &&
                      (pageState.data.length > 0 || recordNotFound) && (
                        <Paper className="pad-top-20 mg-bottom-20">
                          <CustomSearch
                            searchQuery={searchQuery}
                            searchedRecord={searchedRecord}
                            setSearchedRecord={setSearchedRecord}
                            setSearchQuery={setSearchQuery}
                            getDataByPage={getSportHoursData}
                            searchData={getSportHoursData}
                            pageState={pageState}
                            setRecordNotFound={setRecordNotFound}
                          />
                          <DataGrid
                            rows={pageState.data}
                            rowCount={pageState.total}
                            loading={pageState.isLoading}
                            pagination
                            page={pageState.page}
                            pageSize={pageState.pageSize}
                            columns={HoursTableColumns}
                            rowsPerPageOptions={[10]}
                            paginationMode="server"
                            sx={{
                              color: "black",
                              fontFamily: "Rajdhani-SemiBold",
                              fontSize: "18px",
                              backgroundColor: "white",
                              borderBottomLeftRadius: "12px",
                              borderBottomRightRadius: "12px",
                            }}
                            onCellClick={(param) => {
                              history.push(
                                `/hoursgrapschart/${param.row.sportId}`
                              );
                            }}
                            autoHeight
                            disableColumnMenu
                            getRowId={(row) => row.sportId}
                            getRowHeight={() => "auto"}
                            disableSelectionOnClick
                          />
                        </Paper>
                      )}

                    {!loading &&
                      !pageState.data.length > 0 &&
                      !recordNotFound && <ErrorMessage />}
                  </div>
                </>
              )}
              <div className="clear20"></div>
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </div>
  );
};

export default Hours;
